import { combineReducers } from 'redux'
import isActive from './isActive'

export default combineReducers({
  isActive,
})
